module.exports = __webpack_public_path__ + "static/img/ZA.04671dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/ZA.svg
// module id = 4fRl
// module chunks = 1